import DefaultMyProfile from "src/components/feature/MyProfile";

const MyProfile = () => {
  return <DefaultMyProfile />;
};

export default MyProfile;
